import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { useI18n } from '../i18n';
import { validateInquiryItem } from '../utils/inquiryHelpers';
import InquiryItemCategoryFields from '../components/InquiryItemCategoryFields';

const buildState = (item) => ({
  categoryId: item?.categoryId ?? null,
  categoryName: item?.categoryName || '',
  quantity: item?.quantity ?? 1,
  specifications: item?.specifications || '',
  targetPrice: item?.targetPrice ?? null,
  brandingDescription: item?.brandingDescription || '',
  deliveryRequirements: item?.deliveryRequirements || '',
  reorder: Boolean(item?.reorder),
  files: item?.files || [],
});

export default function InquiryItemModal({
  open,
  onCancel,
  onSave,
  item = null,
  categories = [],
}) {
  const { t } = useI18n();
  const [form, setForm] = useState(() => buildState(item));
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm(buildState(item));
      setErrors({});
    }
  }, [open, item]);

  const updateField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const validationErrors = validateInquiryItem({
    categoryId: form.categoryId,
    quantity: form.quantity,
    specifications: form.specifications,
  });
  const isValid = Object.keys(validationErrors).length === 0;

  const handleOk = () => {
    if (!isValid) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});

    onSave?.({
      id: item?.id || `item-${Date.now()}`,
      categoryId: form.categoryId,
      categoryName: form.categoryName,
      quantity: form.quantity,
      specifications: form.specifications,
      targetPrice: form.targetPrice,
      brandingDescription: form.brandingDescription,
      deliveryRequirements: form.deliveryRequirements,
      reorder: form.reorder,
      files: form.files || [],
      sourcingStatus: item?.sourcingStatus || 'Pending',
      wizardResult: item?.wizardResult ?? null,
    });
  };

  return (
    <Modal
      title={item ? t('Edit Product') : t('Add Product')}
      open={open}
      onCancel={onCancel}
      width={760}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onCancel}>{t('Cancel')}</Button>,
        <Button key="save" type="primary" disabled={!isValid} onClick={handleOk}>{t('Save')}</Button>,
      ]}
    >
      <Form layout="vertical">
        <InquiryItemCategoryFields
          value={form}
          onChange={updateField}
          categories={categories}
          errors={errors}
        />
      </Form>
    </Modal>
  );
}
